import { render, staticRenderFns } from "./IconLogoSpeedio.vue?vue&type=template&id=4a589032&"
import script from "./IconLogoSpeedio.vue?vue&type=script&lang=ts&"
export * from "./IconLogoSpeedio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports